import styled from "styled-components"
import {Heading} from "../../../components/Heading"

const ReportCardHeader = styled(Heading)`
  border-bottom: 1px solid ${(props) => props.theme.borderColorLight};
  padding: ${(props) => props.theme.gutter / 2}px
    ${(props) => props.theme.gutter}px;
`

export {ReportCardHeader}
